import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ inline }) => (inline ? '0' : '15px')};

  label {
    font-size: 18px;
    cursor: pointer;
    margin-bottom: 5px;
  }
`;

export const Field = styled.input`
  border: none;
  border-bottom: ${({ error }) => (error ? '1px solid red' : '1px solid #6b6b6b')};
  padding: 10px 0;
  font-size: 16px;
  font-weight: lighter;
  color: #000;
  text-align: center;
  cursor: pointer;
`;

export const ErrorLabel = styled.span`
  font-size: 14px;
  font-weight: normal;
  color: red;
`;
